import { shippingClient } from 'domain/HttpClients';

export const fetch = (shipmentId, itineraryId = null) => {
  let url = `/api/shipments/shipment/${shipmentId}`;
  if (itineraryId) {
    url += `/${itineraryId}`;
  }
  return shippingClient.Get(url).send();
};

export const printWaybill = (params) => shippingClient
  .Get('/api/shipments/get-waybill-label-link/')
  .withParams(params)
  .send();
